module.exports = __webpack_public_path__ + "static/media/asset_supplier_location.2aab7a4e.svg";